module.exports = __webpack_public_path__ + "img/background_233.adae07e6.png";